import { useQuery } from '@tanstack/react-query';
import { useOrganizationStore } from '@/core/stores/organization.store';
import { organizationUnitsService } from '../api/organization-units.service';
import { ORGANIZATION_UNITS_KEYS } from './queryKeys';

export function useOrgChart(enabled = true) {
  const activeOrganizationId = useOrganizationStore((s) => s.activeOrganizationId);

  return useQuery({
    queryKey: ORGANIZATION_UNITS_KEYS.orgChart(activeOrganizationId ?? ''),
    queryFn: ({ signal }) => organizationUnitsService.getOrgChart(signal),
    staleTime: 60_000,
    enabled: !!activeOrganizationId && enabled,
  });
}
